/**
 * Internal dependencies
 */
import './templates';
